import { useEffect, useState } from 'react';

// Big −/+ number for the painter count. The input keeps its own text while
// someone is typing, so clearing it to type "25" doesn't snap back to 1
// halfway through; the board only updates once the text is a valid number.
// `small` is the compact one beside a sentence (canvases posted separately).
function CountStepper({ value, min, max, onChange, lessLabel, moreLabel, inputLabel, small = false }) {
  const [text, setText] = useState(String(value));

  useEffect(() => {
    setText(String(value));
  }, [value]);

  function commit(raw) {
    const n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n < min) return;
    onChange(Math.min(n, max));
  }

  return (
    <div className={small ? 'of-stepper' : 'of-count'}>
      <button
        type="button"
        className={small ? undefined : 'of-count-btn'}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label={lessLabel}
      >
        &minus;
      </button>
      <input
        className={small ? 'of-stepper-value' : 'of-count-input'}
        type="number"
        inputMode="numeric"
        min={min}
        max={max}
        value={text}
        aria-label={inputLabel}
        onChange={(e) => {
          setText(e.target.value);
          commit(e.target.value);
        }}
        // Typing over the number is the quick way: a click selects it all.
        onFocus={(e) => e.target.select()}
        // Enter just confirms the number - it must not submit the order form.
        onKeyDown={small ? (e) => e.key === 'Enter' && (e.preventDefault(), e.target.blur()) : undefined}
        onBlur={() => setText(String(value))}
      />
      <button
        type="button"
        className={small ? undefined : 'of-count-btn'}
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label={moreLabel}
      >
        +
      </button>
    </div>
  );
}

export default CountStepper;
